import React from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import {
  GetWellnessProgramByClientName,
  GetBenchmark,
  UpdateData,
} from "../../../../api/User/ACG/ClientWellnessProgramApi";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";

const ClientWellnessProgram = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const clientId = useSelector((state) => state.clientData.value?.clientID);

  const overrideColumn = [
    { title: "Wellness Program", field: "wellness_Program" },
    {
      title: "Offered",
      minWidth: "74px",
      maxWidth: "75px",
      cellStyle: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
      sorting: false,
      render: (rowData) => (
        <>
          <Form.Check
            type="checkbox"
            checked={rowData.offered}
            className="d-flex aling-items-center juctify-content-center py-2 mx-auto  "
            id={rowData.id}
            disabled={rowData.wellness_Program === "Disease Management" || rowData.wellness_Program === "Health Coaching" || rowData.wellness_Program === "Health Risk Questionnaire"}
            value={JSON.stringify(rowData)}
            style={{ top: "1rem", scale: "1.4", maxWidth: "75px" }}
            onClick={updateCheckBox}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    getWellnessProgramByClientNameData(clientId);
  }, [clientId]);

  const getWellnessProgramByClientNameData = (clientId) => {
    GetWellnessProgramByClientName(clientId)
      .then((res) => {
        if(res.status === 200){
        setData(res.data);
        let checkwellness = res.data.filter((el)=>el.offered)
        if(checkwellness.length === 0){
          ["Disease Management","Health Coaching","Health Risk Questionnaire"].map((item)=>{
            let welnessProgram = res.data.find((el)=>el.wellness_Program === item)
            updateCheckBox({target:{value:JSON.stringify(welnessProgram)}}, true)
          })
        }
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const updateCheckBox = (e, init) => {
    const { id, client_ID, wellness_Program, offered } = JSON.parse(
      e.target.value
    );
    const payload = {
      id,
      client_ID,
      wellness_Program,
      offered: !offered,
    };

    UpdateData(payload)
      .then((res) => {
        if(res.status === 200 || res.status === 204){
          if(!init || init === undefined){
            toastFile("update");
          }
          getWellnessProgramByClientNameData(clientId);
        }
      })
      .catch((err) => console.log({ err }));
  };

  return (
    <div>
      <CustomMaterialTable
        isExport={false}
        overrideColumn={overrideColumn}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        isLoading={isLoading}
      />
    </div>
  );
};

export default ClientWellnessProgram;
